<template>
  <el-dialog
    @open="onOpen"
    title="Prorrogar Vencimento de Boleto Avulso"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="loading"
    width="500px"
  >
    <el-form size="small" label-position="top">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item label="Data de Prorrogação">
            <el-date-picker
              v-model="dataProrrogacao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>        
        <el-col :span="8">
          <el-form-item label=" ">
            <el-button
              @click="calcularBoletoAvulsoHandler"
              type="primary"
              round
              class="btn-box-shadow"
            >
              Calcular
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-tag type="danger" style="font-size: 13px">
            Data de Vencimento Atual: {{ this.dataVencimento }}
          </el-tag>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Valor">
            <div class="el-input el-input--small">
              <money
                v-bind="moneyFormat"
                disabled
                :value="valor"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="Multa">
            <div class="el-input el-input--small">
              <money
                v-bind="moneyFormat"
                disabled
                :value="multa"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Juros">
            <div class="el-input el-input--small">
              <money
                v-bind="moneyFormat"
                disabled
                :value="juros"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Desconto">
            <div class="el-input el-input--small">
              <money
                v-bind="moneyFormat"
                v-model="descontoProrrogacao"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

       <el-row :gutter="10">
        <el-col :span="24">
          <el-tag type="tag 1" style="margin:20px 0; display:block; font-size: 15px">
            Total de Encargos: {{  util.formatarValor(encargos) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col :span="24">
          <el-form-item label="Total">
            <div class="el-input el-input--small">
              <money
                v-bind="moneyFormat"
                disabled
                :value="total"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="confirmarProrrogacaoBoletoAvulso" type="primary" size="small" round class="btn-box-shadow">Prorrogar</el-button>
      <el-button @click="fechar" type="danger" size="small" round class="btn-box-shadow">Fechar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Money } from 'v-money';

import funcoes from '../../../util/funcoes';

export default {
  props: {
    visibility: Boolean,
    boletoAvulsoProp: Object
  },

  components: {
    Money
  },

  data() {
    return {
      dataVencimento: '',
      boletoAvulso: {},

      dataProrrogacao: '',
      valor: 0,
      multa: 0,
      juros: 0,
      descontoProrrogacao: 0,
      total: 0,

      calculado: false,

      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    }
  },

  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado; }
    }),

    loading() {
      return this.$store.state.loading;
    },

    prorrogarComNovoBoleto() {
      return this.usuarioLogado.imobiliaria.parametros.prorrogarComNovoBoleto;
    },

    util() {
      return funcoes;
    },

    encargos() {
      return this.multa + this.juros;
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),

    ...mapActions('alugueisContratosStore', [
      'calcularBoletoAvulso',
      'prorrogarBoletoAvulso'
    ]),

    onOpen() {
      this.reset();
      this.preencherBoletoAvulsoComInformacoesDaProp();
    },

    fechar() {
      this.$emit('close');
    },

    confirmarProrrogacaoBoletoAvulso() {
      if(this.prorrogarComNovoBoleto) {
        this.$confirm("Um novo boleto será gerado e você precisará fazer a remessa desse boleto. Deseja continuar?", "Atenção", {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'warning'
        }).then(() => {
          this.prorrogarBoletoAvulsoHandler();
        }).catch(() => {});
      } else {
        this.prorrogarBoletoAvulsoHandler();
      }
    },

    prorrogarBoletoAvulsoHandler() {
      if(!this.calculado) {
        this.$message.warning("Você deve calcular o valor do Boleto Avulso");
        return;
      }

      if(!this.dataProrrogacao) {
        this.$message.warning('Forneça uma data válida');
        return;
      }
      
      this.showLoading();
      
      const boletoAvulso = {
        id: this.boletoAvulso.id,
        dataProrrogacao: this.dataProrrogacao,
        descontoProrrogacao: this.descontoProrrogacao
      };

      this.prorrogarBoletoAvulso(boletoAvulso).then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            break;
          case 'FALHA':
            this.$message.warning(resultado.mensagem);
            break;
          case 'ERRO':
          default:
            this.$message.error(resultado.mensagem);
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      })
    },

    calcularBoletoAvulsoHandler() {
      if(!this.dataProrrogacao) {
        this.$message.warning('Forneça uma data válida');
        return;
      }
      const boletoAvulso = {
        id: this.boletoAvulso.id,
        dataPagamento: this.dataProrrogacao,
        descontoProrrogacao: this.descontoProrrogacao
      };

      this.showLoading();
      this.calcularBoletoAvulso(boletoAvulso).then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case 'SUCESSO':
            this.preencherBoletoAvulsoAposCalculo(resultado.item);
            this.calculado = true;
            break;
          case 'ERRO':
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível calcular o Boleto Avulso");
      })
    },

    preencherBoletoAvulsoComInformacoesDaProp() {
      this.boletoAvulso.id = this.boletoAvulsoProp.id;
      this.valor = this.boletoAvulsoProp.valor;
      this.dataVencimento = this.boletoAvulsoProp.dataVencimento
    },

    preencherBoletoAvulsoAposCalculo(boletoAvulso) {
      this.valor = boletoAvulso.valor;
      this.multa = boletoAvulso.multa;
      this.juros = boletoAvulso.juros;
      this.descontoProrrogacao = boletoAvulso.descontoProrrogacao;
      this.total = boletoAvulso.valorPagamento;
    },

    reset() {
      this.boletoAvulso = {};

      this.dataProrrogacao = '';
      this.valor = 0;
      this.multa = 0;
      this.juros = 0;
      this.descontoProrrogacao = 0;
      this.total = 0;
      this.dataVencimento = '';
      this.calculado = false;
    }
  }
}
</script>